/**
 * @author jiangtao
 * @Date 2019/11/12
 * @description 跨页面全局事件注册
 * @param Vue
 * @param opts
 * @example this.$event.$on('global_events', fn)
 * @example this.$event.$emit('global_events', 'xx', 'yy')
 * @return {*}
 */
const plugin = {
  install (Vue) {
    if (!Vue.prototype.$event) {
      Object.defineProperty(Vue.prototype, '$event', {
        value: new Vue()
      })
    }
  }
}

export default plugin
